// Ya Tú Sabes — content & imagery.
// Image URLs are AI-generated placeholders that resolve to permanent URLs at build time.

// The landing slideshow, in order: real photographs taken on the island, never
// generated artwork. The first picture matters most — on a phone it is nearly
// all of what a visitor sees before they scroll.
//
// Every frame here is a photograph, free for commercial use and with no
// attribution required. Credits, in this order: Nils Huenerfuerst, Stephanie
// Klepacki, Peter Hansen, Zetong Li, Eric Ardito.
export const heroSlides = [
  {
    src: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/48e05a388_image.png",
    alt: "A dancer in a yellow skirt with drummers playing behind her at dusk",
    focus: { x: 0.5, y: 0.12 },
  },
  {
    src: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/c97b63695_heroimge1.png",
    alt: "A sunlit crowd dancing outdoors in a plaza",
  },
  {
    src: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/51443d4cd_image.png",
    alt: "Palm trees and a fountain in a sunlit park in San Juan",
  },
  {
    src: "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/a79690cd5_image.png",
    alt: "The old city wall and garita in Old San Juan",
  },
];
// How a visitor reaches the people behind the guide. The contact form delivers
// to the site's editors; this is the same address written out, for anyone who
// would rather mail from their own client — and the address a trust check looks
// for on the About and Contact pages.
export const SITE_EMAIL = "hola.yatusabespr@gmail.com";

// The guide's own editor, on the About page.
export const founderImage =
  "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/9766d302e_792093236_10232563552742575_5700812093349926096_n.jpg";

export const cultureImage = "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/7895b72d9_generated_14634f1b.jpg";

export const chips = [
  "Explore",
  "Gastronomy",
  "Culture",
  "Experiences",
  "Nightlife",
  "Shop",
  "Services",
];

export const experiences = [
  {
    id: "exp-salsa",
    label: "Music · Culture",
    title: "Learn the rhythm of salsa",
    meta: "Santurce · A social night built around Puerto Rican music and movement.",
    rating: "4.9",
    price: "From $35",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/9410dc9c4_generated_78b9b677.jpg",
  },
  {
    id: "exp-ride",
    label: "Explore · Mobility",
    title: "Ride through San Juan",
    meta: "Old San Juan · Electric e-moped rentals and self-guided exploration.",
    rating: "4.9",
    price: "From $25",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/1f226e21e_generated_3ab8ff28.jpg",
  },
  {
    id: "exp-food",
    label: "Food · Culture",
    title: "Taste Puerto Rico after dark",
    meta: "San Juan · A late-night food crawl through local favorites.",
    rating: "4.8",
    price: "From $45",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/22ce3eec5_generated_84d9cf49.jpg",
  },
];

export const neighborhoods = [
  {
    id: "nb-osj",
    name: "Old San Juan",
    desc: "History, architecture and streets that refuse to disappear.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/8bca87cba_generated_c7a42130.jpg",
  },
  {
    id: "nb-santurce",
    name: "Santurce",
    desc: "Art, nightlife, food and the city's creative pulse.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/fe5020226_generated_1e1f2b76.jpg",
  },
  {
    id: "nb-rio",
    name: "Río Piedras",
    desc: "Student energy, old storefronts and new ideas.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/5e8e90cc4_generated_8467b390.jpg",
  },
  {
    id: "nb-hato",
    name: "Hato Rey",
    desc: "Business towers, plazas, restaurants and after-hours life.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/288c505b7_generated_2add79a0.jpg",
  },
  {
    id: "nb-bayamon",
    name: "Bayamón",
    desc: "The metro beyond San Juan.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/feb6c0e1d_generated_0d395835.jpg",
  },
];

export const moods = [
  { label: "Gastronomy", chip: "Gastronomy", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/2f0f79d4e_generated_5b36dfc2.jpg" },
  { label: "Stay out", chip: "Nightlife", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/1ad6b9073_generated_de4c2a1d.jpg" },
  { label: "Art", chip: "Culture", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/72ac0ba75_generated_11be9c6a.jpg" },
  { label: "Get outside", chip: "Experiences", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/a90c95f1c_generated_cdf69fc2.jpg" },
  { label: "Learn", route: "/faq", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/da6a5f2af_generated_bbe5a635.jpg" },
];

export const locals = [
  {
    id: "loc-table",
    label: "Santurce · Food",
    title: "A favorite neighborhood table",
    meta: "Good food, good company, no postcard required.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/20e1cccac_generated_d2b7d1a9.jpg",
  },
  {
    id: "loc-coffee",
    label: "Río Piedras · Café",
    title: "A coffee stop worth knowing",
    meta: "A slower start to the day in the city.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/b31d4686b_generated_5559ff55.jpg",
  },
  {
    id: "loc-view",
    label: "Outdoors",
    title: "Go somewhere unexpected",
    meta: "A different view of the island.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/a857a569b_generated_3f5a4954.jpg",
  },
  {
    id: "loc-night",
    label: "Nightlife · Music",
    title: "Stay out a little later",
    meta: "Music, people and a night with no itinerary.",
    image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/ad0468156_generated_20dcd896.jpg",
  },
];

export const searchable = [
  { title: "Salsa experience", sub: "Santurce · Music & Culture", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/9410dc9c4_generated_78b9b677.jpg" },
  { title: "Loop Experience", sub: "Old San Juan · E-moped", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/1f226e21e_generated_3ab8ff28.jpg" },
  { title: "Río Piedras", sub: "Neighborhood · Local life", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/5e8e90cc4_generated_8467b390.jpg" },
  { title: "Santurce", sub: "Neighborhood · Art & nightlife", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/fe5020226_generated_1e1f2b76.jpg" },
  { title: "Old San Juan", sub: "Neighborhood · History & food", image: "https://media.base44.com/images/public/6ab14311c900c9a264a2d314/8bca87cba_generated_c7a42130.jpg" },
];

export const filterCategories = ["Gastronomy", "Culture", "Experiences", "Nightlife", "Shop", "Services"];
export const filterNeighborhoods = ["San Juan", "Santurce", "Río Piedras", "Bayamón", "Hato Rey", "Old San Juan"];